import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['recipientsContainer', 'contactableTypeField', 'contactableIdField'];
  static values = {
    contacts: Object,
    contactableIds: Object,
    preselectedIds: Object,
  };

  connect() {
    this.contactsByType = this.contactsValue;
    this.contactableIdsMap = this.contactableIdsValue;
    this.preselectedIdsMap = this.preselectedIdsValue;
  }

  updateRecipients(event) {
    const contactableType = event.target.value;
    const multiSelectChipController = this.getMultiSelectChipController();
    if (!multiSelectChipController) return;

    if (this.hasContactableIdFieldTarget) {
      if (contactableType && this.contactableIdsMap[contactableType]) {
        this.contactableIdFieldTarget.value = this.contactableIdsMap[contactableType];
      } else {
        this.contactableIdFieldTarget.value = '';
      }
    }

    if (!contactableType) {
      multiSelectChipController.refreshOptions([]);
      return;
    }

    const contacts = this.contactsByType[contactableType] || [];

    if (contactableType === 'Applicant') {
      this.recipientsContainerTarget.classList.add('hidden');
      if (contacts.length > 0) {
        multiSelectChipController.refreshOptions(contacts);
        setTimeout(() => {
          multiSelectChipController.preselectByIds([String(contacts[0].id)]);
        }, 0);
      }
    } else {
      this.recipientsContainerTarget.classList.remove('hidden');
      multiSelectChipController.refreshOptions(contacts);

      const preselectedIds = this.preselectedIdsMap[contactableType] || [];
      if (preselectedIds.length > 0) {
        setTimeout(() => {
          multiSelectChipController.preselectByIds(preselectedIds.map(String));
        }, 0);
      }
    }
  }

  getMultiSelectChipController() {
    const multiSelectChipElement = this.recipientsContainerTarget.querySelector('[data-controller="multi-select-chips-with-search"]');
    if (!multiSelectChipElement) return null;

    return this.application.getControllerForElementAndIdentifier(
      multiSelectChipElement,
      'multi-select-chips-with-search'
    );
  }
}
